export const Featues=[
    {
        heading:"Superior Data",
        desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt quasi facere culpa tempora, ut eos eum veniam modi nobis soluta!'
    },
    {
        heading:"Superior Data",
        desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt quasi facere culpa tempora, ut eos eum veniam modi nobis soluta!'
    },
    {
        heading:"Superior Data",
        desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt quasi facere culpa tempora, ut eos eum veniam modi nobis soluta!'
    },
    {
        heading:"Superior Data",
        desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt quasi facere culpa tempora, ut eos eum veniam modi nobis soluta!'
    },
]
